import { createContext } from 'react';

var AutocompleteContext = /*#__PURE__*/createContext({
  containerId: '',
  focusableOptions: [],
  focusedOption: -1,
  isMultiselect: false
});
var AutocompleteInputContext = /*#__PURE__*/createContext({
  optionsListVisible: false,
  onChange: function () {
    return null;
  },
  value: ''
});
var AutocompleteOptionsContext = /*#__PURE__*/createContext({
  options: [],
  listBoxRef: {
    current: null
  },
  onOptionSelect: function () {
    return null;
  }
});
var AutocompleteSelectedOptionsContext = /*#__PURE__*/createContext({
  onDelete: function () {
    return null;
  },
  onReset: function () {
    return null;
  }
});

export { AutocompleteContext, AutocompleteInputContext, AutocompleteOptionsContext, AutocompleteSelectedOptionsContext };
